<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Istoric login"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
                <el-form-item label='Tip actiune' >
                  <el-select class='full-width' v-model='Filters.Actiuni' >
                    <el-option label="Toate" value="-1"></el-option>
                    <el-option label="Login" value="login"></el-option>
                    <el-option label="Logout" value="Logout"></el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Utilizator">
                <el-select class="full-width" v-model="Filters.UserId" filterable>
                  <el-option label="Toti" value="-1"></el-option>
                  <el-option
                    v-for="item in Info.utilizatori"
                    :key="'utilizatori' + item.UserId"
                    :label="item.Nume"
                    :value="item.UserId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Interval'>
                <br>
                <el-date-picker                            
                    v-model="Filters.Data"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Data inceput"
                    end-placeholder="Data sfarsit"
                    :picker-options="datePickerOptions"
                    format="dd/MM/yyyy" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <!-- <table cellpadding="10" class="tabel-data" style="margin-top: 10px; width: 100%">
      <thead>
          <tr class="cell-data">
            <th>#</th>
            <th>Nume utilizator</th>
            <th>Actiune</th>
            <th>Info</th>
            <th>Data</th>
            <th>IP</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="item in Results" :key="'rand' + item.Id" >
            <td>{{item.Id}}</td>
            <td >{{item.NumeUtilizator}}</td>
            <td >{{item.Actiune}}</td>
            <td >{{item.Info}}</td>
            <td >{{item.DataEveniment | DataOra()}}</td>
            <td >{{item.IP}}</td>
          </tr>
        </tbody>
      </table> -->

      <el-table :data="Results">
      <el-table-column prop="Id" label="#" width="80px"></el-table-column>
      <el-table-column prop="NumeUtilizator" label="Nume utilizator"></el-table-column>
      <el-table-column prop="Actiune" label="Actiune"></el-table-column>
      <el-table-column prop="Info" label="Info"></el-table-column>
      <el-table-column label="Data">
        <template slot-scope="scope">
          {{ scope.row.DataEveniment | DataOra() }}
        </template>
      </el-table-column>
      <el-table-column prop="IP" label="IP Intern"/>
      <el-table-column prop="IP2" label="IP  Extern"/>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
  </base-page>
</template>

<script>
import moment from "moment";
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "istoric_login",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      base_url: "",
      Info: {
      },
      Filters: {
        UserId: "-1",
        Actiuni: "-1",
        IdDeviz: "-1",
        Data: [],
        Numar: "",
      },
      OrderBy: {'Id': 'DESC'},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async get_info() {
      var response = await this.post("admin/istoric_login/get_info");
      this.Info.utilizatori = response.utilizatori;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/istoric_login/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("setari");
    },
    reset() {
      this.Filters = {
        UserId: "-1",
        Actiuni: "-1",
        Data: [],
        Numar: "",
      };
      this.refresh_info();
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right('Management')){
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 31%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
.tabel-data {
  word-break: keep-all;
  
}
</style>
